import { defaultOptions } from "@/components/engines/paid";

// Engine toggles with paid badge + per-engine option selects (e.g. MVSEP quality). options = {engineKey: {opt: value}}
export const EnginePicker = ({ engines, picked, setPicked, options, setOptions, columns = "sm:grid-cols-2 lg:grid-cols-3", testPrefix = "benchmark-engine" }) => {
  const toggle = (e) => {
    const on = picked.includes(e.key);
    setPicked(on ? picked.filter((x) => x !== e.key) : [...picked, e.key]);
    if (!on && !options[e.key]) setOptions({ ...options, [e.key]: defaultOptions(e) });
  };
  return (
    <div className={`grid ${columns} gap-2`}>
      {engines.map((e) => {
        const on = picked.includes(e.key);
        return (
          <div key={e.key} className={`rounded-sm border transition-colors ${on ? "border-cyan-500 bg-cyan-500/10" : "border-[#253044]"}`}>
            <button data-testid={`${testPrefix}-${e.key}-toggle`} onClick={() => toggle(e)} className="w-full text-left p-3 hover:bg-[#1E2738]/60 rounded-sm">
              <div className="flex items-center justify-between gap-2">
                <div className="text-sm font-medium">{e.name}</div>
                {e.paid && <span data-testid={`engine-paid-badge-${e.key}`} className="font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm border text-amber-300 border-amber-700 bg-amber-400/10">paid</span>}
              </div>
              <div className={`text-[11px] mt-1 ${e.configured ? "text-emerald-400" : "text-amber-400"}`}>{e.configured ? "configured" : "not configured — will record failure"}</div>
            </button>
            {on && Object.entries(e.options || {}).map(([opt, schema]) => (
              <label key={opt} className="block px-3 pb-3">
                <span className="micro">{schema.label}</span>
                <select data-testid={`engine-option-${e.key}-${opt}`} value={options[e.key]?.[opt] ?? schema.default}
                  onChange={(ev) => setOptions({ ...options, [e.key]: { ...(options[e.key] || {}), [opt]: ev.target.value } })}
                  className="mt-1 w-full bg-[#0B0E14] border border-[#253044] rounded-sm px-2 py-1.5 text-xs">
                  {schema.choices.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </label>
            ))}
          </div>
        );
      })}
    </div>
  );
};
